import _ from 'underscore';

import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { IsNlpEnabled } from '~src/lens/utils/LensUtil';
import { isMetricsEnabled } from '~src/metrics/util/MetricUtils';
import { isProjectSpace, SpaceInfo } from '~src/spacesPlatform/state/SpaceInfo';

import { MixedContentItemDefinition } from '../../contentDefinitionInterfaces/ContentDefinitionsTypes';
import { ExplorableItemType } from '../../models/ContentType';

export namespace FilterByTypeDropdownHelpers {
  export const getContentDefinitions = (
    useShowWorkbooksAsViews: boolean,
    showWorkbooksAsViews: boolean,
    flowsEnabled: boolean,
    hiddenContentTypes: ReadonlyArray<ExplorableItemType> = [],
    contentItemDefinitions: MixedContentItemDefinition[],
    spaceInfo: SpaceInfo
  ): MixedContentItemDefinition[] => {
    const items: MixedContentItemDefinition[] = [];

    for (const typeDef of contentItemDefinitions) {
      if (
        (typeDef.itemType === 'databaseWithCrass' && !isProjectSpace(spaceInfo)) ||
        (typeDef.itemType === 'tableWithCrass' && !isProjectSpace(spaceInfo)) ||
        (typeDef.itemType === 'flow' && !flowsEnabled) ||
        (typeDef.itemType === 'metric' && !isMetricsEnabled()) ||
        (typeDef.itemType === 'lens' && !IsNlpEnabled()) ||
        (typeDef.itemType === 'virtualConnection' && !FeatureFlags.publishedConnectionContentManagementEnabled) ||
        (typeDef.itemType === 'collection' && !FeatureFlags.useCollectionsFavorites) ||
        (typeDef.itemType === 'predictiveModel' && !FeatureFlags.prometheusPredictiveModelEnabled) ||
        (hiddenContentTypes.length && _.contains(hiddenContentTypes,typeDef.itemType))) {
        continue;
      }

      if (useShowWorkbooksAsViews) {
        if (!showWorkbooksAsViews && typeDef.itemType === 'view') {
          // Showing workbooks only.
          continue;
        } else if (showWorkbooksAsViews && typeDef.itemType === 'workbook') {
          // Showing views instead.
          continue;
        }
      }
      items.push(typeDef);
    }

    return items;
  };

  export const showingViewsOrWorkbooks = (currentTypeFilters: ReadonlyArray<ExplorableItemType>): boolean => {
    return _.some(currentTypeFilters, (contentType: ExplorableItemType) => {
      return contentType === 'workbook'
        || contentType === 'view';
    });
  };

  export const isCurrentlyFilteredContentType = (value: string, currentTypeFilters: ReadonlyArray<ExplorableItemType>) => {
    return _.some(currentTypeFilters, (selectedItem) => {
      if (selectedItem === 'dataconnection') {
        return value === 'datasource';
      }else if (selectedItem === 'database'){
        // TFSID: 1392281 to remove this hack
        // The explore content uses database as itemType but the api request for fetching databases uses 
        // databaseWithCrass. So had to place this temporary hack itemTypes
        return value === 'databaseWithCrass';
      } else if(selectedItem === 'table') {
        return value === 'tableWithCrass';
      }
      return selectedItem === value;
    });
  };

}
